import { lifecycle } from "recompose";

export default lifecycle({
  componentDidMount() {
    const { exportReasons, fetchExportReasons } = this.props;
    // TODO: add version 2 logic
    exportReasons.length === 0 && fetchExportReasons();
  },
});
